import React from "react";
import GalleryPage from "./GalleryPage";
import sage_and_sky_header from "../img/sage_and_sky/sage_and_sky_header.png";
import { Beloved } from "../ui/BelovedStyles";

const BelovedPage = () => (
  <>
    <Beloved className="container">
      <div className="row">
        <div className="col-xs-1" />
        <div className="col-xs-10">
          <div className="thumbnail">
            <img src={sage_and_sky_header} alt="Beloved" />
          </div>
        </div>
        <div className="col-xs-1" />

        <div className="col-xs-1" />
        <div className="col-xs-10 description">
          The desert is a place that has always intrigued me with its vast and
          dramatic landscapes, and the creatures that call such a harsh and
          rugged environment home. I’ve always found it beautiful, with its
          plants and animals feeling quite magical to me.
          <br />
          <br />
          Inspired by moments in my life over the past year, from places I saw
          and animals I encountered. From creating in my cozy home studio to
          plein air painting, each of these pieces holds a special memory.
          <br />
          <br />
          This collection was inspired by this feeling, the high desert, and the
          local wildlife in Northern Nevada.
          <br />
          <br />
          For more information or to purchase, email
          lupineravenartworks@gmail.com
          <br />
          <br />
          @ Sierra Arts ANNEX Gallery | 17 S. Virginia St. Suite 120
          <br />
          This collection will be on display from January 1st - 25th 2026
        </div>
        <div className="col-xs-1" />
      </div>
    </Beloved>

    <div className="row">
      <div className="col-sm-1 col-xs-0" />
      <div className="col-sm-10 col-xs-12">
        <div className="thumbnail">
          <GalleryPage media="sage_and_sky" />
        </div>
      </div>
      <div className="col-sm-1 col-xs-0" />
    </div>
  </>
);

export default BelovedPage;
